import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';

@Injectable({
  providedIn: 'root'
})
export class OriginsService {

  constructor() {
  }

  list(page: number = 0, count: number = 999999): Observable<DWS.Page<DWS.Origin>> {
    return resource('crm://origins')
      .params(
        { page, count }
      )
      .get<DWS.Page<DWS.Origin>>();
  }
}
